import {Component, ComponentRef, Input, OnChanges, OnDestroy, SimpleChanges, Type, ViewChild, ViewContainerRef} from '@angular/core';
import {Subscription} from 'rxjs';

@Component({
  selector: 'core-modal-outlet',
  standalone: true,
  imports: [],
  template: `<ng-container #vc></ng-container>`
})
export class ModalOutlet  implements OnChanges, OnDestroy {
  @Input({required: true}) component!: Type<unknown>;
  @Input() inputs: Record<string, unknown> = {};

  // Cambia esto: ahora permite valores undefined (Partial)
  @Input() outputs: Partial<Record<string, (value: unknown) => void>> = {};

  @ViewChild('vc', {read: ViewContainerRef, static: true})
  private readonly vc!: ViewContainerRef;

  private ref?: ComponentRef<any>;
  private subs: Subscription[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['component']) {
      this.mount();
      return;
    }

    this.applyInputs();
    this.bindOutputs();
  }

  ngOnDestroy(): void {
    this.cleanup();
  }

  private mount() {
    this.cleanup();
    this.vc.clear();
    this.ref = this.vc.createComponent(this.component);
    this.applyInputs();
    this.bindOutputs();
  }

  private applyInputs() {
    if (!this.ref) return;
    Object.entries(this.inputs ?? {}).forEach(([key, value]) => {
      this.ref!.setInput?.(key, value);
      if (!this.ref!.setInput) this.ref!.instance[key] = value;
    });
  }

  private bindOutputs() {
    if (!this.ref) return;

    this.subs.forEach(s => s.unsubscribe());
    this.subs = [];

    for (const [outputName, handler] of Object.entries(this.outputs ?? {})) {
      if (!handler) continue; // <-- clave para evitar undefined

      const out = this.ref.instance?.[outputName];
      if (out && typeof out.subscribe === 'function') {
        this.subs.push(out.subscribe((v: unknown) => handler(v)));
      }
    }
  }

  private cleanup() {
    this.subs.forEach(s => s.unsubscribe());
    this.subs = [];
    this.ref?.destroy();
    this.ref = undefined;
  }
}
